<div>
  <p>Ez a fájl nem ehhez a táblához tartozik.</p>
  <p>
    A feltöltött fájl a(z) <strong>{{ wrongTemplate.label }}</strong> tábla
    sablonjának felel meg. Szeretné, hogy inkább oda töltsük fel?
  </p>
  <div class="flex justify-content-end">
    <button
      class="mr-3 p-button-text"
      [disabled]="uploading"
      [icon]="uploading ? 'pi pi-spin pi-spinner' : ''"
      (click)="uploadToCorrectTable()"
      pButton
      type="button">
      {{ uploading ? 'Feltöltés folyamatban...' : 'FELTÖLTÉS A(Z) "' + wrongTemplate.label + '" TÁBLÁHOZ' }}
    </button>
    <button
      (click)="ref.close()"
      class="p-button-text"
      [disabled]="uploading"
      pButton
      type="button">
      MÉGSE
    </button>
  </div>
</div>
